var React = require('react');

function IconExpertAdvice (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 3389","d":"M250.44 250H0a125.282 125.282 0 0178.79-116.305 74.988 74.988 0 1193.185.11A125.257 125.257 0 01250.44 250zM500 50v125a24.984 24.984 0 01-25 25H300.245a24.984 24.984 0 01-25-25v-24.755L225.73 100l49.51-25V50a24.984 24.984 0 0125-25H475a24.984 24.984 0 0125 25zm-99.755 75h-75v25h75zm50-50h-125v25h125z","fill":"#10457a"}));
}

IconExpertAdvice.defaultProps = {"width":"500","height":"250","viewBox":"0 0 500 250"};

module.exports = IconExpertAdvice;

IconExpertAdvice.default = IconExpertAdvice;
